import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
import exportMethod from './export'
/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:54
* @route '/reports/daily/print'
*/
export const print = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: print.url(options),
    method: 'get',
})

print.definition = {
    methods: ["get","head"],
    url: '/reports/daily/print',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:54
* @route '/reports/daily/print'
*/
print.url = (options?: RouteQueryOptions) => {
    return print.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:54
* @route '/reports/daily/print'
*/
print.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: print.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:54
* @route '/reports/daily/print'
*/
print.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: print.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:54
* @route '/reports/daily/print'
*/
const printForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: print.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:54
* @route '/reports/daily/print'
*/
printForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: print.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Reports\DailyReportController::print
* @see app/Http/Controllers/Admin/Reports/DailyReportController.php:54
* @route '/reports/daily/print'
*/
printForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: print.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

print.form = printForm

const daily = {
    export: Object.assign(exportMethod, exportMethod),
    print: Object.assign(print, print),
}

export default daily